import { IntegrationEnhanced } from "@/api/integrations";
import { IntegrationConnection } from "@cohesive/api-client";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useConnectMCP } from "./useConnectMCP";
import { useConnectNango } from "./useConnectNango";
import { useConnectPipedream } from "./useConnectPipedream";

export function useConnectIntegration({
  autoClose = true,
}: {
  autoClose?: boolean;
} = {}) {
  const queryClient = useQueryClient();

  const connectNangoMutation = useConnectNango();
  const connectPipedreamMutation = useConnectPipedream({ autoClose });
  const connectMCPMutation = useConnectMCP();

  return useMutation({
    mutationFn: async (integration: IntegrationEnhanced) => {
      let ic: IntegrationConnection | null = null;

      if (integration.provider === "nango") {
        ic = await connectNangoMutation.mutateAsync(integration);
      }

      if (integration.provider === "pipedream") {
        const result = await connectPipedreamMutation.mutateAsync(integration);
        if (result && typeof result === "object" && "cancelled" in result) {
          return false; // User cancelled
        }
        ic = result;
        if (ic && typeof ic === "object" && "cancelled" in ic) {
          return false; // User cancelled
        }
      }

      if (integration.provider === "mcp") {
        const result = await connectMCPMutation.mutateAsync(integration);
        if (result && typeof result === "object" && "cancelled" in result) {
          return false; // User cancelled
        }
        return result;
      }

      return ic;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["integrationConnections"],
        refetchType: "all",
      });
      queryClient.invalidateQueries({
        queryKey: ["orgIntegrations"],
      });
    },
  });
}
